<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
		<div class="container">
			<!-- 本所动态 -->
			<a-spin :spinning="loading">
				<div class="party-active flex justify-between" v-if="!loading">
					<newsSwiper :list="newsSwiper" :type="1" width="534px" height="382px" radius="8px"></newsSwiper>
					<div class="list">
						<div class="flex justify-between align-center title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-24">{{newsList[0].newsType.newsType}}</div>
							</div>
							<router-link tag="a"
								:to="{path:'/news/list',query:{homeMenuFirstId:newsList[0].newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:newsList[0].newsType.id}}">
								<img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt="">
							</router-link>
						</div>
						<!-- 列表 -->
						<div v-for="(item,index) in newsList[0].pageList.records"
							v-if="index<=7  && newsList[0].pageList.records.length>=0"
							class="item border-bottom-dott padding-tb-18 flex justify-between align-center hover-item">
							<div class="item-title color-1a font-16 overflow-eli">
								·<router-link class="hover-a line-1" tag="a"
									:to="{path:'/news/info',query:{newsId:item.id}}">
									{{item.newsTitle}}
								</router-link>
							</div>
							<div class="time color-999">{{item.releaseTime}}</div>
						</div>
						<div v-if="newsList[0].pageList.records.length<=0" class="padding-top-15">
							<a-empty style="padding:50px;" description="暂无数据" />
						</div>
					</div>
				</div>
			</a-spin>
			<!-- 本所动态模板结束 -->

			<div class="flex justify-between flex-wrap" v-if="!loading">
				<!-- 本所公告 -->
				<div class="basic-box margin-bottom-15" v-for="(item,index) in normalList">
					<div class="flex justify-between align-center title">
						<div class="flex align-center">
							<div class="line"></div>
							<div class="color-1a margin-left-5 font-24">{{item.newsType.newsType}}</div>
						</div>
						<router-link tag="a"
							:to="{path:'/news/list',query:{homeMenuFirstId:item.newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:item.newsType.id}}">
							<img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt="">
						</router-link>
					</div>
					<div v-for="(news,newsIndex) in item.pageList.records"
						v-if="newsIndex<=6 && item.pageList.records.length>=0"
						class="item border-bottom-dott padding-tb-18 flex justify-between align-center hover-item">
						·<div class="item-title color-1a font-16 overflow-eli">
							<router-link class="hover-a" tag="a" :to="{path:'/news/info',query:{newsId:news.id}}">
								{{news.newsTitle}}
							</router-link>
						</div>
						<div class="time color-999">{{news.releaseTime}}</div>
					</div>
					<div v-if="item.pageList.records.length<=0" class="padding-top-15">
						<a-empty style="padding:50px;" description="暂无数据" />
					</div>
				</div>
				<!-- 本所公告结束 -->
			</div>
			<!-- 挂牌公告结束 -->
			<div class="clear"></div>
			<!-- 市场资讯 -->
			<div class="spical-box" v-for="(item,index) in newsList"
				v-if="index==newsList.length-1 && newsList.length>1 && newsList.length%2==0 && !loading">
				<div class="flex justify-between align-center title">
					<div class="flex align-center">
						<div class="line"></div>
						<div class="color-1a margin-left-5 font-24">{{item.newsType.newsType}}</div>
					</div>
					<router-link tag="a"
						:to="{path:'/news/list',query:{homeMenuFirstId:item.newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:item.newsType.id}}">
						<img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt="">
					</router-link>
				</div>
				<div class="padding-top-15" v-if="item.pageList.records.length>=0" style="overflow: hidden;">
					<vue-seamless-scroll :data="item.pageList.records" :class-option="seamlessScrollOption"
						class="scroll_box">
						<div class=" flex justify-between">
							<div class="item" v-for="(news,newsIndex) in item.pageList.records" v-if="newsIndex<3">
								<router-link :to="{path:'/news/info',query:{newsId:news.id}}" tag="a"><img width="428"
										height="260" class="radius-8 cover" :src="$api.baseUrl+$api.imgPath+news.pcImageUrl"
										alt=""></router-link>
								<div class="item-title">{{news.newsTitle}}</div>
							</div>
						</div>
					</vue-seamless-scroll>
				</div>
				<div v-if="item.pageList.records.length<=0" class="padding-top-15">
					<a-empty style="padding:50px;" description="暂无数据" />
				</div>
			</div>
			<!-- 市场资讯结束 -->
		</div>
	</div>
</template>

<script>
	import newsSwiper from "@/components/NewsSwiper"
	import vueSeamlessScroll from 'vue-seamless-scroll'
	export default {
		components: {
			newsSwiper,
			vueSeamlessScroll
		},
		data() {
			return {
				headBg: "",
				newsSwiper: [],
				newsList: [],
				normalList:[],
				menuPosition: "",
				loading: true,
				moreIcon: require("../../assets/more.png"),
				moreIconActive: require("../../assets/more_active.png"),
			}
		},
		watch: {
			'$route.query'() {
				Object.assign(this.$data, this.$options.data())
				this.menuPosition = this.$route.query.menuPosition;
				this.init();
			}
		},
		created() {
			document.title = "雄安股权交易所-新闻公告";
			this.menuPosition = this.$route.query.menuPosition;
			this.init();
		},
		mounted() {
			console.log("This code was written by a four years old child,whose name is ZhuChenXi.");
		},
		computed: {
			seamlessScrollOption() {
				return {
					step: 0.5, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 2, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 3000, // 单步运动停止的时间(默认值1000ms)
				};
			}
		},
		methods: {
			init() {
				this.getHeadBanner();
				this.getRecommendNews();
				this.getNews();
			},
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			getRecommendNews() {
				this.$request({
					url: this.$api.news.getRecommendNews,
					data: {
						menuId: this.menuPosition
					},
				}).then((res) => {
					this.newsSwiper = res.data.result;
					console.log(this.newsSwiper);
					// this.loading = false;
				})
			},
			getNews() {
				this.$request({
					url: this.$api.news.getNewsType,
					data: {
						menuId: this.menuPosition,
					},
				}).then((res) => {
					this.newsList = res.data.result;
					let _list = JSON.parse(JSON.stringify(res.data.result));
					let _length = _list.length-1;
					if(_length%2==0){
						this.normalList = _list;
						this.normalList.splice(0,1);
					}else{
						this.normalList = _list;
						this.normalList.splice(0,1)
						this.normalList.splice(this.normalList.length-1,1)
					}
					this.loading = false;
				})
			},
			moreEnter(e) {
				e.target.src = this.moreIconActive;
			},
			moreLeave(e) {
				e.target.src = this.moreIcon;
			}

		}
	}
</script>

<style scoped="scoped">
	.study-box {
		width: 590px;
		min-height: 410px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		padding: 30px;
	}

	.scroll_box {
		/* width: 100%; */
	}

	.spical-box {
		width: 1200px;
		padding: 20px;
		overflow: hidden;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		margin-bottom: 24px;
	}

	.spical-box .item {
		width: 360px;
		height: 250px;
		margin-left: 15px;
		margin-right: 15px;
		position: relative;
	}

	.spical-box .item img {
		width: 100%;
		height: 250px;
		object-fit: cover;
		transition: all 0.3s;
	}

	.spical-box .item .item-title {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		background-color: rgba(0, 0, 0, 0.6);
		color: white;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		transition: linear 0.2s;
	}

	.spical-box .item:hover img {
		filter: brightness(50%);
	}

	.spical-box .item:hover .item-title {
		color: #1A1A1A;
		width: 90%;
		left: 5%;
		bottom: 15px;
		border-radius: 8px;
		overflow: hidden;
		white-space: pre-wrap;
		text-overflow: ellipsis;
		background-color: white;
	}

	.basic-box {
		width: 590px;
		min-height: 410px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		padding: 20px;
	}

	.basic-box .item-title {
		width: 400px;
	}

	.study-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.basic-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.spical-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.content {
		/* position: relative; */
	}

	.content .container {
		z-index: 1;
	}

	body {
		background-color: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.party-active {
		width: 100%;
		/* min-height: 490px; */
		background: #FFFFFF;
		border-radius: 8px;
		padding: 20px;
		/* margin-top: -55px; */
		margin-top: 40px;
		z-index: 999;
		margin-bottom: 16px;
	}

	.party-active .list {
		width: 600px;
	}

	.party-active .list .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.bg-gray {
		background: #F6F7FC;
		min-height: 300px;
	}

	.text-red {
		color: #FD2F35;
	}

	.time {
		width: 100px;
		text-align: right;
	}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.hover-item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.hover-item:hover a {
		color: #13B8EE;
	}

	.padding-bottom-15 {
		padding-bottom: 15px;
	}

	.padding-top-15 {
		padding-top: 15px;
	}

	.padding-top-13 {
		padding-top: 13px;
	}

	.border-bottom-dott {
		border-bottom: 1px dotted #D9D9D9;
	}

	.hover-a {
		color: #1A1A1A;
	}

	.hover-a:hover {
		color: #13B8EE;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.clear {
		clear: both;
	}
</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue